module.exports = import("https://unpkg.com/xlsx/xlsx.mjs");;